const pathnameArray = location.pathname.split('/');
const pathname = location.pathname.replace(/\/+$/, "").split('/').pop();


const roomOtherList = [...document.querySelectorAll('.p-room-lower-other-rooms__list li')];
const roomOtherListIdArray = roomOtherList.map(list => list.getAttribute('id'));

roomOtherListIdArray.forEach((id, index) => {
  if(id === pathname){
    roomOtherList[index].style.display = 'none';
  }
})
